import React from 'react';

interface InputProps {
  index: number;
  id: string;
  handleChange: (value: string) => void;
  showStatistics: boolean;
  answer: string | undefined;
  votePercent: string;
  option: string;
}

const Input: React.FC<InputProps> = ({
  index,
  id,
  handleChange,
  answer,
  votePercent,
  showStatistics,
  option,
}: InputProps) => {
  return (
    <label key={index} htmlFor={`${index}-${id}`} className="poll-label">
      <input
        className={`${showStatistics ? 'show-stats' : ''}`}
        onChange={(e) => handleChange(e.target.value)}
        aria-disabled={showStatistics}
        disabled={showStatistics}
        aria-checked={answer === String(index)}
        checked={answer === String(index)}
        value={String(index)}
        type="radio"
        id={`${String(index)}-${id}`}
        name={`${index}-${id}`}
      />
      <div
        className={`progress-bar ${answer === String(index) ? 'user' : ''}`}
        style={{
          width: `${showStatistics ? votePercent : 0}%`,
        }}
      />
      <div className="label-info">
        <span>{option}</span>
        {showStatistics && `${votePercent}%`}
      </div>
    </label>
  );
};

export { Input };
